/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metric_Launch_Switch_To_DateInputs */



/**
* | output |
* | --- |
* | "Switch to Launch Date" |
*
* @param {Metric_Launch_Switch_To_DateInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const metric_launch_switch_to_date = /** @type {((inputs?: Metric_Launch_Switch_To_DateInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metric_Launch_Switch_To_DateInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Switch to Launch Date")
});